import http from "@/http-common";
import httpMultipart from "@/http-multipart";
import baseUrl from "@/base-url";

const BASE = "/evaluation";

function toFormData(data) {
  const formData = new FormData();

  const append = (key, value) => {
    if (value === undefined || value === null) return;
    if (typeof Blob !== "undefined" && value instanceof Blob) {
      formData.append(key, value);
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item, index) => append(`${key}[${index}]`, item));
      return;
    }
    if (typeof value === "object") {
      Object.entries(value).forEach(([childKey, childValue]) => {
        append(`${key}.${childKey}`, childValue);
      });
      return;
    }
    formData.append(key, String(value));
  };

  Object.entries(data || {}).forEach(([key, value]) => append(key, value));
  return formData;
}

class EvaluationService {
  approve(data) {
    // Approval is exposed by the Plus controller, not /web/evaluation.
    // Keep the authenticated HTTP client; an absolute URL avoids its /web/ prefix.
    return http.put(`${baseUrl.url.replace(/\/$/, "")}/mob/plus/evaluation/approve`, data);
  }

  getEvaluationFileUrl(objectKey) {
    return http.get(`${BASE}/file-url`, { params: { objectKey } });
  }

  // ─── Daily ──────────────────────────────────────
  createDaily(data) {
    return httpMultipart.post(`${BASE}/daily`, toFormData(data));
  }

  createDailyBatchCommon(data) {
    return httpMultipart.post(`${BASE}/daily/batch-common`, toFormData(data));
  }

  updateDaily(data) {
    return httpMultipart.put(`${BASE}/daily`, toFormData(data));
  }

  deleteDaily(params) {
    return http.delete(`${BASE}/daily`, { params });
  }

  // ─── Weekly ─────────────────────────────────────
  createWeekly(data) {
    return httpMultipart.post(`${BASE}/weekly`, toFormData(data));
  }

  createWeeklyBatchCommon(data) {
    return httpMultipart.post(`${BASE}/weekly/batch-common`, toFormData(data));
  }

  updateWeekly(data) {
    return httpMultipart.put(`${BASE}/weekly`, toFormData(data));
  }

  deleteWeekly(params) {
    return http.delete(`${BASE}/weekly`, { params });
  }

  // ─── Monthly ────────────────────────────────────
  createMonthly(data) {
    return httpMultipart.post(`${BASE}/monthly`, toFormData(data));
  }

  createMonthlyBatchCommon(data) {
    return httpMultipart.post(`${BASE}/monthly/batch-common`, toFormData(data));
  }

  updateMonthly(data) {
    return httpMultipart.put(`${BASE}/monthly`, toFormData(data));
  }

  deleteMonthly(params) {
    return http.delete(`${BASE}/monthly`, { params });
  }

  // ─── Reply ──────────────────────────────────────
  createReply(data) {
    return http.post(`${BASE}/reply`, data);
  }

  updateReply(data) {
    return http.put(`${BASE}/reply`, data);
  }

  deleteReply(params) {
    return http.delete(`${BASE}/reply`, { params });
  }

  // ─── Query ──────────────────────────────────────
  getByStudent(params) {
    return http.get(`${BASE}/by-student`, { params });
  }

  getByClass(params) {
    return http.get(`${BASE}/by-class`, { params });
  }

  // ─── Activity Log ───────────────────────────────
  getActivityLog(params) {
    return http.get(`${BASE}/activity-log`, { params });
  }

  // ─── Export Excel APIs ───────────────────────────
  getExportClassSheetData(data) {
    return http.post(`${BASE}/export/class-sheet`, data);
  }

  getExportStudentSheetsData(data) {
    return http.post(`${BASE}/export/student-sheets`, data);
  }

  approveBatch(data) {
    return http.put(`${BASE}/approval/batch`, data);
  }
}

export default new EvaluationService();
